module.exports = __webpack_public_path__ + "img/video-connectivy-3.6c7a3ac6.png";